import { render, staticRenderFns } from "./TemplateGeneratorTodayDate.vue?vue&type=template&id=0646cb6d&"
import script from "./TemplateGeneratorTodayDate.vue?vue&type=script&lang=js&"
export * from "./TemplateGeneratorTodayDate.vue?vue&type=script&lang=js&"
import style0 from "./TemplateGeneratorTodayDate.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports